import mammoth from "mammoth";

/**
 * @param {ArrayBuffer} arrayBuffer
 * @returns {Promise<string>}
 */
export async function ingestDocx(arrayBuffer) {
  const { value } = await mammoth.extractRawText({ arrayBuffer });
  return (value || "").trim();
}
